import CartDrawer from "@/app/shared/ecommerce/cart/cart-drawer";
// import FloatingCart from '@/app/shared/floating-cart';
import { CartProvider } from "@/store/quick-cart/cart.context";
import { Outlet } from "react-router-dom";

export default function EcommerceLayout() {
    return (
        <CartProvider>
            {<Outlet />}
            <CartDrawer />
        </CartProvider>
    );
}
